import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFeedDto, queryKeys, useAccessToken } from "src/http";

const useGetRoleFeedRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getRoleFeedRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.roles.getRoleFeed>>): Promise<GetFeedDto> {
    const accessToken = await getAccessToken();
    const [{ roleGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/roles/${roleGuid}/feed`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getRoleFeedRequest };
};

const useGetRoleFeed = (roleGuid: string) => {
  const { getRoleFeedRequest } = useGetRoleFeedRequest();

  return useQuery({
    queryKey: queryKeys.roles.getRoleFeed(roleGuid),
    queryFn: getRoleFeedRequest,
  });
};

export { useGetRoleFeed };
